import connector from 'api/http';
import config from 'shared/config';

import { TokenResponse } from './types';

const MERCHANT = 'live_payment';

const paymentApi = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getToken: (): Promise<TokenResponse> =>
      server.get('/paymentgateway/getToken', {
        merchant: MERCHANT,
      }),
  };
};

export default paymentApi;
